import { Link } from 'react-router-dom';
import Button from '../components/Button';

const NotFoundPage = () => {
  return (
    <main className='flex min-h-screen items-center justify-center px-4'>
      <div className='max-w-md w-full text-center'>
        {/* Error Code */}
        <div className='mb-8'>
          <h1 className='text-6xl sm:text-8xl font-bold text-white/50 mb-4'>
            404
          </h1>
          <div className='w-16 h-0.5 bg-gradient-to-r from-mint to-yellow mx-auto mb-6'></div>
        </div>

        {/* Error Message */}
        <div className='mb-8'>
          <h2 className='text-2xl sm:text-3xl font-medium text-white mb-4'>
            Page Not Found
          </h2>
          <p className='text-white/60 text-base'>
            The page you're looking for doesn't exist.
          </p>
        </div>

        {/* Actions */}
        <div className='space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center'>
          <Link to='/' className='block'>
            <Button
              color='mint'
              size='md'
              className='w-full sm:w-auto'
              aria-label='Go back to homepage'
            >
              Go Home
            </Button>
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
